import { useEffect } from "react";
import { useSearchStore } from "..";

export default function (key: number | undefined, callback: () => void): void {
    const searchStore = useSearchStore();

    useEffect(() => {
        if (key === undefined)
            return;

        searchStore.addOpenSelectedItemCallback(key, callback);
        return () => searchStore.removeOpenSelectedItemCallback(key);
    }, [callback]);
}